import {Component, OnInit} from '@angular/core';
import {UserService} from "../../../services/user.service";
import {FormBuilder, FormControl, FormGroup, Validators} from "@angular/forms";
import {AuthService} from "../../../services/auth.service";
import {UserVO} from "../../../generate/UserVO";
import {requiredFieldValidator} from "../../../validators/required-field-validator.directive";
import {AppConfigService} from "../../../services/app.config.service";
import {NgxSmartModalService} from "ngx-smart-modal";
import {MfaRecoveryCodeResponse} from "../../../model/mfaRecoveryCodeResponse";

@Component({
  selector: 'lib-two-factor-authentication',
  templateUrl: './two-factor-authentication.component.html',
  styleUrls: ['./two-factor-authentication.component.scss']
})
export class TwoFactorAuthenticationComponent implements OnInit {
  get successMessage(): string {
    return this._successMessage;
  }

  set successMessage(value: string) {
    this._errorMessage = undefined;
    this._successMessage = value;
  }

  get errorMessage(): string {
    this._successMessage = undefined;
    return this._errorMessage;
  }

  set errorMessage(value: string) {
    this._errorMessage = value;
  }
  qrdata: string;
  form: FormGroup;
  private _successMessage: string;
  private _errorMessage: string;
  currentUser: UserVO;

  modalContent: string = null;
  twoFactorModelRandomID: string;
  generateRecoveryCodesRandomID: string;
  commentModalHeader: string;
  showRecoveryCodes = false;
  recoveryCodes: string[];

  constructor(
    private userService: UserService,
    private authService: AuthService,
    private formBuilder: FormBuilder,
    private appConfigService: AppConfigService,
    private ngxSmartModalService: NgxSmartModalService
  ) {}

  ngOnInit(): void {
    this.form = this.formBuilder.group({
      code: new FormControl('', [requiredFieldValidator, Validators.maxLength(6)])
    });
    this.currentUser = this.authService.currentUserAuthVO();
    this.twoFactorModelRandomID = Math.random().toString(36).substring(7);
    this.generateRecoveryCodesRandomID = Math.random().toString(36).substring(7);
  }

  setup() {
    this.userService.setup2FA().subscribe(data => {
      this.qrdata = data.totpuri;
    });
  }

  confirmDisable() {
    this.modalContent = 'Are you sure you want to disable two-factor authentication?';
    this.commentModalHeader = 'Disable 2FA';
    this.ngxSmartModalService.open(this.twoFactorModelRandomID);
  }

  confirmGenerateNewRecoveryCodes() {
    this.modalContent = 'Are you sure you want to generate new account recovery codes? All previous codes will be invalidated.';
    this.commentModalHeader = 'Confirmation';
    this.ngxSmartModalService.open(this.generateRecoveryCodesRandomID);
  }

  generateRecoveryCodes() {
    this.userService.generateRecoveryCodes().subscribe({
      next: (data: MfaRecoveryCodeResponse) => {
        this.recoveryCodes = data.mfaRecoveryCodes;
        this.showRecoveryCodes = true;
        this.ngxSmartModalService.close(this.generateRecoveryCodesRandomID);
      },
      error: () => {
        this._errorMessage = 'Recovery Codes failed to generate';
        this.ngxSmartModalService.close(this.generateRecoveryCodesRandomID);
      }
    });
  }

  disable2FA(event: any) {
    this.userService.disable2FA().subscribe({
      next: () => {
        const user = this.authService.currentUserSubject.getValue();
        if (user) {
          user.totpEnabled = false;
          this.currentUser = user;
          this.authService.storeUserAuthVO(user);
        }
        this.ngxSmartModalService.close(this.twoFactorModelRandomID);
      },
      error: () => {
        // No extra action required
        this._errorMessage = '2FA disabling failed';
      }
    });
  }

  onSubmit() {
    if (this.form.valid) {
      this.userService.verify2FA(this.form.get('code').value).subscribe(data => {
        this.successMessage = '2FA setup succeeded';
        const user = this.authService.currentUserSubject.getValue();
        if (user) {
          user.totpEnabled = true;
          this.currentUser = user;
          this.authService.storeUserAuthVO(user);
        }
        this.qrdata = undefined;
        this.generateRecoveryCodes();
      }, error => {
        // No extra action required
        if(error && error.message){
          this.errorMessage = error.message;
        } else {
          this.errorMessage = 'Invalid two-factor authentication code';
        }
      });
    }
  }

  cancel() {
    this.qrdata = undefined;
  }

  printRecoveryCodes() {
    const printContent = document.getElementById("recovery-codes");
    const temporaryPrintPage = window.open('', '', 'left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0');
    temporaryPrintPage.document.write('<head><title>Recovery Codes</title></head>');
    temporaryPrintPage.document.write(printContent.innerHTML);
    temporaryPrintPage.document.close();
    temporaryPrintPage.focus();
    temporaryPrintPage.print();
    temporaryPrintPage.close();
  }

  downloadRecoveryCodes() {
    const blob = new Blob([this.recoveryCodes.join('\n')], { type: 'text' });
    const url = window.URL.createObjectURL(blob);
    const fileLink = document.createElement('a');
    fileLink.href = url;
    fileLink.download = 'recovery-codes.txt';
    fileLink.click();
  }

  copyCodesToClipboard() {
    this._successMessage = 'Recovery Codes Copied!';
    navigator.clipboard.writeText(this.recoveryCodes.join('\n'));
  }
}
